import { getDefaultLogo } from "@/utils/utils";
import { Card, Flex } from "antd";
import { useBranding } from "../../../../branding/store";

export const DashboardLogoWidget = () => {
  const branding = useBranding();

  return (
    <Card style={{ height: "100%", borderRadius: 18 }} styles={{ body: { height: "100%", padding: "16px 24px" } }}>
      <Flex align="center" justify="center" style={{ height: "100%" }}>
        <img
          style={{ maxHeight: "100%", maxWidth: "100%" }}
          src={branding?.logoResourcePath ? `/images/${branding.logoResourcePath}` : getDefaultLogo("dark")}
          alt="Dashboard logo"
        />
      </Flex>
    </Card>
  );
};
